<app-header></app-header>
<div class="responsive">
    <div class="container-fluid">



        <div class="row">
            <div class="col-md-3">
                <app-sidebar></app-sidebar>
            </div>
            <div class="col-md-6">
                <div class="row">
                    <div class="col-md-12">
                        <app-sub-header title="Support"></app-sub-header>

                        <div style="text-align: end;">

                            <button routerLink='create-Ticket' class="btn margin-b main-backgroundcolor color">Create
                                Ticket</button>
                        </div>

                        <div class="margin-b">
                            <div class="display margin-b">
                                <div class="header header-button cursor" [ngClass]="{'active':activeTab === 'OPEN'}"
                                    (click)="getScrollTo('OPEN')" id="OPEN">OPEN
                                </div>
                                <div class="header header-button cursor" [ngClass]="{'active':activeTab === 'RESOLVE'}"
                                    (click)="getScrollTo('RESOLVE')" id="RESOLVE">RESOLVE
                                </div>
                                <div class="header header-button cursor" [ngClass]="{'active':activeTab === 'CANCEL'}"
                                    (click)="getScrollTo('CANCEL')" id="CANCEL">CANCEL
                                </div>

                            </div>
                        </div>



                        <app-no-results-found *ngIf="supportArr?.length == 0 && loading" title='Support Messages'>
                        </app-no-results-found>



                        <div *ngIf="!loading">
                            <div class="card " *ngFor="let props of arr">
                                <div style="position:relative">
                                    <div class="display">
                                        <div class="header">
                                            <app-skelton></app-skelton>
                                        </div>
                                        <div class="header pos">
                                            <app-skelton></app-skelton>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <h5 class="card-title margin-b">
                                        <app-skelton></app-skelton>
                                    </h5>
                                    <div style="position:relative">
                                        <div class="display" style="border-bottom: none;">
                                            <div>
                                                <app-skelton></app-skelton>
                                            </div>
                                            <div class="pos">
                                                <app-skelton></app-skelton>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>



                        <div class="card card-style margin-b" *ngFor="let props of (supportArr  | paginate
                        : {
                            itemsPerPage: pageSize,
                            currentPage: pageNo,
                            totalItems: totalItems
    
                          })">
                            <div style="position:relative">
                                <div class="display border-style">
                                    <div class="header">
                                        Ref. ID - {{props._id}}
                                    </div>


                                    <div class="header pos">
                                        {{props.title }}
                                    </div>
                                </div>
                            </div>
                            <div class="card-body cursor" (click)="navigate(props._id)">
                                <p class="margin-b">{{props.description}}</p>
                                <div style="position:relative">
                                    <div class="display">
                                        <div>Time:{{props.createdAt  | date:'medium'}}</div>
                                        <div class="pos" style="left: 82%; transform: translateX(-8%);
                                        ">Status: {{props.status}}</div>
                                    </div>

                                </div>
                            </div>
                        </div>



                    </div>
                </div>
                <div *ngIf="loading" class="col-md-12" style="text-align: center;">
                    <pagination-controls class="col s12 col-md-offset-3 my-pagination"
                        *ngIf="supportArr?.length == pageSize" (pageChange)="page = getSupport($event)"
                        directionLinks="true" autoHide="false" responsive="true" previousLabel="Previous"
                        nextLabel="Next" screenReaderPaginationLabel="Pagination" screenReaderPageLabel="page"
                        screenReaderCurrentLabel="You're on page">
                    </pagination-controls>
                </div>

            </div>
            <div class="col-md-3">
                <app-events [showheader]=true></app-events>

            </div>
        </div>
    </div>
</div>